// components/PaymentModal.jsx
import React, { useEffect } from 'react';
import './PaymentModal.css';

const PaymentModal = ({ paymentUrl, onSuccess, onError, onClose }) => {
  useEffect(() => {
    // Listen for payment response from popup
    const handleMessage = (event) => {
      // Check origin for security
      // if (event.origin !== window.location.origin) return;
      
      if (event.data && event.data.status) {
        if (event.data.status === 'Success') {
          onSuccess(event.data);
        } else {
          onError(event.data.status);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onSuccess, onError]);

  const openPaymentPopup = () => {
    const width = 800;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    
    window.open(
      paymentUrl,
      'PaymentGateway',
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  };

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <div className="modal-header">
          <h3>Complete Payment</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <p>You will be redirected to the secure payment gateway.</p>
          
          <div className="payment-amount">
            <strong>Amount:</strong> ₹100.00
          </div>
          
          <div className="payment-instructions">
            <h4>Instructions:</h4>
            <ul>
              <li>Do not refresh or close the payment window</li>
              <li>Keep your payment details ready</li>
              <li>You will be redirected back after payment</li>
            </ul>
          </div>
          
          <button className="btn-pay" onClick={openPaymentPopup}>
            Proceed to Payment
          </button>
          
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;